import React from "react";
import Subtitle from "@radarly/components/cards/card/subtitle";
import { DatavizTopAuthors } from "@radarly/models/dataviz";
import { SearchableInfluencer } from "@radarly/models/influencer";
import { SearchFragmentUsers } from "@radarly/models/search";
import Date from "@radarly/shared/cards/subtitle/date";
import Tile from "@radarly/shared/cards/tile";
import TopAuthors from "@radarly/shared/widgets/authors/top-authors";
import { CardFragmentProps } from "../model";

const RadarlyAuthorsCardTopAuthors = ({
  title,
  fragment,
  project,
  dataviz,
  height,
  onClickItem,
  timezone,
  forceReload,
  nowDate,
}: CardFragmentProps<
  SearchFragmentUsers,
  DatavizTopAuthors,
  SearchableInfluencer
>) => {
  return (
    <Tile
      title={title}
      subtitle={
        <Subtitle
          meta={[
            <Date fragment={fragment} timezone={timezone} nowDate={nowDate} />,
          ]}
        />
      }
      height={height}
      clause={fragment.request.query}
    >
      <TopAuthors
        fragment={fragment}
        project={project.id}
        dataviz={dataviz}
        onClickInfluencer={onClickItem}
        forceReload={forceReload}
        timezone={timezone}
      />
    </Tile>
  );
};

export default RadarlyAuthorsCardTopAuthors;
